import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FaqsComp from '../../components/faqs';
import { getFaqs } from '../../slices/faqSlice';
import LoaderCP from '../../components/loader';

const FaqSection = () => {
  const dispatch = useDispatch();
  const { faq, status } = useSelector((state) => state.faq);

  useEffect(() => {
    dispatch(getFaqs());
  }, []);

  return (
    <div>
      {status === 'loading' ? <LoaderCP /> : ''}
      {status === 'failed' ? '' : ''}
      {status === 'success' && faq.length > 0
        ? <FaqsComp faqs={faq} />
        : '' }
    </div>
  );
};

export default FaqSection;
